var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.noToggle)?_c('span',[_vm._t("default")],2):_c('span',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:(_vm.collapseId),expression:"collapseId"}],staticClass:"toggle-link"},[_vm._t("default"),_vm._v(" "),_c('b-icon',{attrs:{"icon":"caret-right-fill"}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }